// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:750px){#aw--c #aw-sl .loading-moment-box[data-v-0a8bc8d4]{min-height:65px!important;max-height:65px!important}}", ""]);
// Exports
module.exports = exports;
